import React, { useImperativeHandle, useRef } from "react";
import '../../styles/main.css';
import CxSnackbar from './CxSnackbar';
import { useTranslation } from '../hx/useTranslation';
import * as FxLog from '../fx/FxLog';
import * as FxFetch from '../fx/FxFetch';
import { MdRecordVoiceOver } from "react-icons/md";
import { AiOutlineLoading3Quarters } from "react-icons/ai"; // Nuevo icono

const CxSpeechWhisper = props => {
  const [{ trans }] = useTranslation();
  const { setVal, onSpeechFinish } = props;

  const r_snack_speak_now = useRef(null);
  const r_snack_browser_does_not_support = useRef(null);
  const r_snack_processing = useRef(null); 

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const currentValueRef = useRef(""); 

  const setGlobalSelection = (enable) => {
    const value = enable ? "auto" : "none";
    document.body.style.userSelect = value;
    document.body.style.webkitUserSelect = value;
    if (!enable) window.getSelection()?.removeAllRanges(); 
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) audioChunksRef.current.push(event.data);
      };

      mediaRecorder.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
        stream.getTracks().forEach(track => track.stop());

        r_snack_speak_now.current?.setOpen(false); 
        r_snack_processing.current?.setOpen(true); 

        const reader = new FileReader();
        reader.readAsDataURL(audioBlob);
        reader.onloadend = async () => {
          const base64data = reader.result.split(',')[1];
          try {
            const responseData = await FxFetch.doJsonX('speech/transcribe', { 
              audioBase64: base64data, 
              formato: 'webm' 
            });

            if (responseData && responseData.theStatus === 'OK' && responseData.theValue) {
              const prevText = currentValueRef.current.trim();
              const newText = prevText ? `${prevText} ${responseData.theValue}` : responseData.theValue;
              setVal(newText);
              setTimeout(() => {
                if (onSpeechFinish) onSpeechFinish(newText);
              }, 0);              
            }
          } catch (error) {
            FxLog.errorx('CxSpeechWhisper.fetchError', error);
          } finally {
            // Se cierra solo cuando termina el proceso, gracias al null del componente
            r_snack_processing.current?.setOpen(false);
            setGlobalSelection(true);
          }
        };
      };

      setGlobalSelection(false); 
      mediaRecorder.start();
      r_snack_speak_now.current?.setOpen(true);

    } catch (err) {
      FxLog.infox('CxSpeechWhisper.startError', err);
      r_snack_browser_does_not_support.current?.setOpen(true);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === "recording") {
      mediaRecorderRef.current.stop();
    }
  };

  useImperativeHandle(props.xref, () => ({
    getType: () => 'CxSpeechWhisper',
    doStartStop: (activeId, startStop, currentValue) => {
      if (startStop === 1) { 
        currentValueRef.current = currentValue || "";
        startRecording();
      } else { 
        stopRecording();
      }
    },
    reset: () => { currentValueRef.current = ""; }
  }));

  return (
    <>
      <CxSnackbar 
        xref={r_snack_speak_now} 
        severity="warning" 
        autoHideDuration={null} 
        hideIcon={true} 
        value={
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#fff' }}>
            <MdRecordVoiceOver fontSize={22} className="blink" /> 
            <span>{trans('msg.speak_now')}</span>
          </div>
        } 
      />

      <CxSnackbar 
        xref={r_snack_browser_does_not_support} 
        severity="error" 
        value={trans('msg.browser_doesnt_support_x', 'field.voice_recognition')} 
      />

      <CxSnackbar 
        xref={r_snack_processing} 
        severity="info" 
        autoHideDuration={null}
        hideIcon={true} // Ocultamos el icono por defecto de Material/Info
        value={
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#fff' }}>
            <AiOutlineLoading3Quarters className="spin-animation" fontSize={20} /> 
            <span>{trans('msg.processing_dictation_with_ai')}</span>
          </div>
        } 
      />

    </>
  );
};

export default CxSpeechWhisper;